import React, { useState } from "react";
import { auth, googleProvider, db } from "./firebaseConfig";
import { signInWithEmailAndPassword, signInWithPopup, sendPasswordResetEmail } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);

      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }
      console.log("Remember ME:", rememberMe, "Email:", email);

      alert("Login successful!");
      navigate("/dashboard");
    } catch (error) {
      alert(error.message);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      alert("Please enter your email");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent! Check your inbox.");
    } catch (error) {
      alert(error.message);
    }
  };


  const handleGoogleLogin = async () => {
    try {
      const userCredential = await signInWithPopup(auth, googleProvider);
      const user = userCredential.user;


      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await setDoc(userRef, {
          username: user.displayName || "Google User",
          email: user.email,
          bio: "",
          savedQuizzes: [],
          quizHistory: [],
        });
      }

      alert("Google Sign-In successful!");
      navigate("/dashboard");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className='wrapper'>
      <h2>Login</h2>
      <form onSubmit={handleLogin} action="">
        <div className="input-box">
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required /> <FaUser className='icon' />
        </div>
        <div className="input-box">
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required /> <FaLock className='icon' />
        </div>


        <div className="remember-forgot">
          <label><input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} /> Remember me</label>

          <span onClick={handlePasswordReset} >Forgot Password?</span>
        </div>

        <button type="submit">Login</button>
      </form>

      <button onClick={handleGoogleLogin}>Login in with Google</button>

      <div className="register-link">
        <p>Don't have any account? <span onClick={() => navigate("/signup")} className="register-click-link" >Register</span></p>
      </div>
    </div>
  );
};

export default Login;
